module.exports = __webpack_public_path__ + "img/wellbng_economy.mars.4802066.png";